module.exports = __webpack_public_path__ + "static/media/kuning.7c28d14d.svg";